import { put, select } from 'redux-saga/effects';
import { registerModal } from '../actions/modalActions';

export function* updateModalSaga(action) {
  const modal = yield select(state => state.modal);
  modal.setContent(action.payload);
  modal.show();

  yield put(registerModal(modal));
}

export function* closeModalSaga() {
  const modal = yield select(state => state.modal);
  modal.hide();

  yield put(registerModal(modal));
}
